import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import useStore from "../store/useStore";
import { useLocation } from "react-router-dom";

export default function PalabrasCarousel() {
  const { clientes, fetchClientes } = useStore();
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  useEffect(() => {
    fetchClientes();
  }, [fetchClientes]);

  // Aplanar el array de imágenes y conservar info relevante
  const allImages = clientes
    ? clientes.flatMap((cliente) =>
        (Array.isArray(cliente.img)
          ? cliente.img
          : cliente.img
          ? [cliente.img]
          : []
        ).map((imagen) => ({
          url: imagen.url,
          alt: cliente.nombre || "Cliente",
          opacidad: imagen.opacidad || "",
        }))
      )
    : [];

  // Filtrar imágenes únicas por url
  const uniqueImages =
    allImages && Array.isArray(allImages)
      ? allImages.filter(
          (img, idx, arr) => arr.findIndex((i) => i.url === img.url) === idx
        )
      : [];

  function splitInGroups(array, n) {
    const result = [];
    const groupSize = Math.ceil(array.length / n);
    for (let i = 0; i < n; i++) {
      result.push(array.slice(i * groupSize, (i + 1) * groupSize));
    }
    return result;
  }

  const groups = splitInGroups(uniqueImages, 4);

  const local = process.env.REACT_APP_STRAPI_URL;

  return (
    <div
      data-testid="palabras-carousel"
      className="w-full  bg-sidom-blue flex flex-col items-center justify-center"
    >
      <div
        data-aos="fade-up"
        data-aos-delay="100"
        className="container mt-[70px] md:mt-[100px] lg:mt-[90px]"
      >
        <h1 className="text-sidom-orange text-3xl md:text-[40px] px-2 md:px-0 lg:px-0 lg:text-[45px] leading-tight font-extrabold w-full text-left mb-[60px]">
          Clientes
        </h1>
      </div>
      <div className="mb-[100px] w-full">
        {groups.map((group, idx) => (
          <div className="container" key={"swiper-group-" + idx}>
            {group.length > 0 && (
              <div className="mb-2 w-full">
                <Swiper
                  spaceBetween={10}
                  slidesPerView={3}
                  loop={true}
                  speed={7000}
                  autoplay={{
                    delay: 1,
                    disableOnInteraction: false,
                    reverseDirection: idx % 2 === 0,
                  }}
                  modules={[Autoplay]}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    400: { slidesPerView: 3, spaceBetween: 10 },
                    640: { slidesPerView: 4, spaceBetween: 10 },
                    1024: { slidesPerView: 8, spaceBetween: 10 },
                  }}
                  className="w-full"
                >
                  {group.map((marca, i) => (
                    <SwiperSlide
                      key={marca.url + i + "-" + idx}
                      className="flex items-center justify-center"
                    >
                      <img
                        data-aos="fade-up"
                        data-aos-delay="100"
                        src={`${local}${marca.url}`}
                        alt={marca.alt}
                        className={`h-20 md:h-24 object-contain transition duration-300 mx-auto rounded-lg shadow ${marca.opacidad}`}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
